export default __webpack_public_path__ + "static/media/DigitalOcean.cf46b35c.svg";